import { z } from 'zod'

import type { ZodInfer } from '@mntn-dev/utility-types'

/**
 * AnyUrn urn:{nss}:{nid}
 * e.g. urn:project:5cff7e31-db22-488f-a116-6ff437b62a35
 */
export const AnyUrnSchema = z
  .string()
  .regex(
    /^urn:([^:]+):[0-9a-f]{8}-[0-9a-f]{4}-[0-9a-f]{4}-[0-9a-f]{4}-[0-9a-f]{12}$/
  )
  .transform((input) => input as `urn:${string}:${string}`)
export type AnyUrn = ZodInfer<typeof AnyUrnSchema>
